import { MapPin } from "lucide-react";
import DeliverySearchBar from "../components/DeliverySearchBar";

export default function ShopsPage() {
  return (
    <div className="min-h-screen" data-testid="shops-page">
      {/* Hero Header */}
      <section className="relative bg-forest py-20 px-6 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-white/20 blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-48 h-48 rounded-full bg-brand-pink/30 blur-3xl"></div>
        </div>
        
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <span className="inline-block text-xs font-sans uppercase tracking-[0.2em] text-brand-pink font-bold mb-4">
            Flowerlive
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-white mb-4 leading-tight">
            Dove vuoi far arrivare <span className="italic">i fiori?</span>
          </h1>
          <p className="text-white/70 mb-10 max-w-2xl mx-auto text-base sm:text-lg">
            Inserisci l'indirizzo di destinazione e troveremo il fiorista perfetto per te
          </p>

          <div className="max-w-xl mx-auto" data-testid="shops-search">
            <DeliverySearchBar variant="page" />
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-16 px-6 md:px-12 max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          {[
            { title: "Fiorista affiliato", desc: "Se c'e un nostro partner vicino alla destinazione, ti portiamo direttamente da lui.", range: "Entro 15 km" },
            { title: "Flowerlive per te", desc: "Se non c'e un partner ma c'e un fiorista nella zona, Flowerlive gestisce tutto.", range: "Tutta Italia" },
            { title: "Consegna garantita", desc: "Ordina a qualsiasi ora, ti confermiamo entro 6 ore lavorative.", range: "6h lavorative" },
          ].map((item, i) => (
            <div key={i} className="p-6 rounded-2xl bg-cream/30">
              <div className="w-12 h-12 rounded-full bg-brand/10 flex items-center justify-center mx-auto mb-4">
                <MapPin className="h-6 w-6 text-brand" />
              </div>
              <h3 className="font-serif text-lg text-forest mb-2">{item.title}</h3>
              <p className="text-sage text-sm leading-relaxed mb-3">{item.desc}</p>
              <span className="text-xs uppercase tracking-wider text-brand font-bold">{item.range}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
